/**
 * GoToTop
 */

import Config from './Config';
import Util from './Util';

let INSTANCE: Toast = null;

class Toast {

	private name: string;

	private parent: string;

	private delay: number;

	private succeccCss: string;

	private failCss: string;

	private timeout: any;

	constructor() {
		if ( !INSTANCE ) {
			this.name = 'toast-layer';
			this.parent = 'body';
			this.delay = 3000;
			this.succeccCss = 'is-success';
			this.failCss = 'is-fail';
			this.timeout = 0;

			INSTANCE = this;
		}

		return INSTANCE;
	}

	public getCss( isSuccess = true ) {
		return ( isSuccess ) ? ` ${this.succeccCss}` : ` ${this.failCss}`;
	}

	public template( msg: string, isSuccess: boolean = false ) {
		const _css = this.getCss( isSuccess );
		return `<div class="${this.name}${_css}"><div class="msg">${msg}</div></div>`;
	}

	public show( msg: string, isSuccess: boolean = false ) {
		const _tmpl = jQuery( this.template( msg, isSuccess ) );

		if ( this.timeout ) {
			this.quickHide();
		}

		clearTimeout( this.timeout );

		jQuery( this.parent ).append( _tmpl.hide() );
		_tmpl.fadeIn();

		this.timeout = setTimeout( () => {
			this.hide();
		}, this.delay );
	}

	public quickHide() {
		jQuery( `.${this.name}` ).hide();
	}

	public fadeIn() {
		jQuery( `.${this.name}` ).fadeIn();
	}

	public hide() {
		jQuery( `.${this.name}` ).fadeOut();
	}
}

export default new Toast();
